import styled, { css } from 'styled-components';

export const Wrapper = styled.span`
  display: inline-block;
  line-height: 0;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px;
    `}

  svg {
    ${(props) =>
      props.width &&
      css`
        width: ${props.width}px;
      `}
    ${(props) =>
      props.height &&
      css`
        height: ${props.height}px;
      `}
  }
`;
